import { createFileRoute } from "@tanstack/react-router";
import { ruleInventorySearchSchema } from "@/features/groups/schemas";
import { fetchMembershipRules } from "@/features/groups/queries";
import { RuleInventoryPage } from "@/features/groups/pages/rule-inventory-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenants/$slug/groups/rules")({
  validateSearch: ruleInventorySearchSchema,
  loaderDeps: ({ search }) => ({ cursor: search.cursor }),
  loader: ({ context, deps }) => context.queryClient.ensureQueryData({
    queryKey: queryKeys.groups.ruleInventory(context.tenant.id, deps.cursor),
    queryFn: () => fetchMembershipRules(context.tenant.id, deps.cursor),
    staleTime: 0,
  }),
  component: RuleInventoryPage,
});
